import { PropsWithChildren } from "react";
import { Client, ClientContext } from "./ClientContext";

interface Props {
  client: Client;
}
export const ClientContextProvider = ({ client, children }: PropsWithChildren<Props>) => (
  <ClientContext.Provider value={client}>{children}</ClientContext.Provider>
);
